import { defineCopy } from "../intl";
import type { BrandLinkKey } from "./links.types";
import { BRAND_LINKS_COPY_EN_US } from "./en-us/links.copy";
import { BRAND_LINKS_COPY_ES_ES } from "./es-es/links.copy";

/** Rótulo de cada link de marca (exceto suporte, que é dado). */
export const BRAND_LINKS_COPY_PT_BR = {
  site: "Conhecer a Tãmi",
  signUp: "Criar minha conta",
  instagram: "Instagram",
  youtube: "YouTube",
  guide: "Guia completo da Tãmi",
} as const satisfies Record<Exclude<BrandLinkKey, "supportWhatsApp" | "supportEmail">, string>;

export const BRAND_LINKS_COPY = defineCopy(BRAND_LINKS_COPY_PT_BR, {
  "en-US": BRAND_LINKS_COPY_EN_US,
  "es-ES": BRAND_LINKS_COPY_ES_ES,
});
